import ErrorView from '@Shared/components/ErrorView'
import { isRouteErrorResponse, useRouteError } from 'react-router'

function RouteErrorHandler(): JSX.Element {
  const error = useRouteError()

  if (isRouteErrorResponse(error)) {
    return (
      <ErrorView
        title={error.status + ' ' + error.statusText}
        message={error.data}
      />
    )
  }

  if (error instanceof Error) {
    return <ErrorView title="Error" message={error.message} />
  }

  return <ErrorView title="Error" />
}

export default RouteErrorHandler
